import styled from '@emotion/styled';

const CellWrapper = styled.div`
  min-height: 10px;
`;

export const Cell = ({ children, ...rest }) => (
  <CellWrapper {...rest}>{children}</CellWrapper>
);
